<template>
    <div id="highchart_bar_chart"
      v-bind="$attrs"
      class="wrap-bar-chart-hc"
      :style="'width:' + divwidth + ';'"
  >
          <highcharts :options="chartOptions" ref="chartBar"></highcharts>

      <slot name="content"></slot>
      <div class="highcharts-data-table">
          <table v-if="showTable" class="custom-table">
              <caption class="highcharts-table-caption"></caption>
              <thead>
                  <tr>
                      <th class="highcharts-empty"></th>
                      <!--<th class="highcharts-text">Período</th>-->
                      <th class="highcharts-text" v-for="serie in chartOptions.series" :key="serie.name">
                          {{ serie.name }}
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(categoria, index) in chartOptions.xAxis.categories" :key="index">
                      <td class="highcharts-text">{{ categoria }}</td>
                      <td class="highcharts-number" v-for="serie in chartOptions.series" :key="serie.name + index">
                          <span v-html="isPriceChart?formatIntegerPrice(serie.data[index],2,2):formateQty(serie.data[index])"></span>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</template>

<script>
import { i18n, tb } from '@/i18n';
import { colors } from "@/Composables/ChartColors";
import { formatIntegerPrice } from "@/Mixins/Formatting";
import * as Highcharts from 'highcharts';
import { format } from "highcharts";
import 'highcharts/modules/exporting'
import "highcharts/modules/accessibility";
import "highcharts/modules/export-data";
import "highcharts/modules/no-data-to-display";
import "highcharts/modules/offline-exporting";

export default {
  props: {
      options: {
          type: Object,
          default: function () {
              return {};
          },
      },

      height: {
          type: String,
          default: "100%",
      },

      width: {
          type: String,
          default: "100%",
      },
      divwidth: {
          type: String,
      },
      title: {
          type: String,
          default: "",
      },

      alignTitleLeft: {
          type: Boolean,
          default: false,
      },

      subtitle: {
          type: String,
          default: "",
      },

      toolbar: {
          type: Boolean,
          default: false,
      },

      hideLegend: {
          type: Boolean,
          default: false,
      },

      showDataLabels: {
          type: Boolean,
          default: false,
      },

      distributed: {
          type: Boolean,
          default: false,
      },

      isPriceChart: {
          type: Boolean,
          default: false,
      },

      barHeight: {
          type: String,
          default: "70%",
      },

      categories: {
          type: Array,
          default: function () {
              return [];
          },
      },

      maxLabelWidth: {
          type: Number,
          default: 160,
      },

      annotations: {
          type: Array,
          default: function () {
              return [];
          },
      },

      series: {
          type: Array,
          required: true,
      },

      horizontal: {
          type: Boolean,
          default: false,
      },
      offsetX: {
          type: Number,
          default: 0,
      },
      isFloat: {
          type: Boolean,
          default: false,
      },
  },
  data() {
     return{
        showTable:false
     }
  },
  computed: {
      chartOptions() {
          return {
              exporting:{
                  enabled: true,
                  //url: 'https://code.highcharts.com/12.2.0/lib/',
                  //libURL: 'https://code.highcharts.com/12.2.0/lib/', // Use versão compatível
                  fallbackToExportServer: false, // impede uso do export server
                  sourceWidth: 1920,
                  sourceHeight: 1080,
                  buttons: {
                      contextButton: {
                          menuItems: [
                              'viewFullscreen',
                                  'printChart',
                                  'separator',
                                  'downloadPNG',
                                  'downloadJPEG',
                                  'downloadSVG',
                                  'separator',
                                  'downloadCSV',
                                  //'downloadXLS',
                                  {
                                      text: this.showTable ? i18n.t('charts.hideData') : i18n.t('charts.viewData'),
                                      onclick: () => {
                                          this.showTable = !this.showTable
                                      }
                                  },
                          ]
                      }
                  }
              },
              lang: {
                      locale: "pt",
                      noData: i18n.t('charts.noData'),
                      exportData: {
                          categoryHeader: "Ano",
                      },
                      contextButtonTitle: i18n.t('charts.menu'),
                      downloadJPEG: i18n.t('charts.downloadJPEG'),
                      downloadPDF: i18n.t('charts.downloadPDF'),
                      downloadPNG: i18n.t('charts.downloadPNG'),
                      downloadSVG: i18n.t('charts.downloadSVG'),
                      downloadCSV: i18n.t('charts.downloadCSV'),
                      downloadXLS: i18n.t('charts.downloadXLS'),
                      viewFullscreen: i18n.t('charts.fullscreen'),
                      printChart: i18n.t('charts.print'),
                      exitFullscreen: i18n.t('charts.exitFullscreen'),
                      viewData: i18n.t('charts.viewData'),
                      loading: i18n.t('charts.loading'),
                      //noData: 'Sem dados para mostrar'
              },
              noData: {
                  text: i18n.t('charts.noData'),
                  align: "center",
                  verticalAlign: "middle",
                  offsetX: 0,
                  offsetY: 0,
                  style: {
                      color: undefined,
                      fontSize: "14px",
                      fontFamily: undefined,
                  },
              },
              chart: {
                  type: "bar",
                  //marginTop:window.innerWidth<=600?60:40,
                  events: {
                      load: function() {
                          var chart = this,
                          barsLength = chart.series.length>0?chart.series[0].data.length:0;

                          chart.update({
                          chart: {
                              height: 300 + 90 * barsLength
                          }
                          }, true, false, false);
                      }
                 }
              },
              title: {
                  text:  _.toUpper(this.title),
                  align: 'left',
                  style: {
                      fontSize: '16px',
                      fontWeight: 'bold',
                      //fontFamily: 'Spartan',
                      color: '#006DB6',
                      //color: '#154579',
                  },
              },
              subtitle: {
                  text: this.subtitle,
                  align: 'left',
              },
              xAxis: {
                  categories: (this.categories || []).map((category) => tb(category)),
                  title: {
                      text: null,
                  },
                  gridLineWidth: 1,
                  lineWidth: 0,
                  maxPadding: 0,
              },

              yAxis: {
                  min: 0,
                  gridLineWidth: 0,
                  title: {
                      text: "",
                      align: "high",
                  },
                  labels: {
                      overflow: "justify",
                      //format:'{value}€'
                      /*formatter: function () {
                          return formatIntegerPrice(this.value)
                      },*/
                      formatter: (t)=> {
                          if(this.isPriceChart){
                              if(t.value>1000){
                              return (t.value/1000).toFixed(1) + "€"
                              }else{
                                  return t.value+ '€'
                              }
                          }else{
                              return this.formateQty(t.value)
                          }

                          //return formatIntegerPrice(this.value)
                      }
                  },
                  //gridLineWidth: 0,
                  //maxPadding: 0,
              },
              tooltip: {
                  //valueSuffix: " millions",
                  //pointFormat:
                    //  "{series.name}:  <b>{point.y:,.1f} €</b><br/>",
                  formatter:this.isPriceChart? function () {
                      return  `<b>${this.key}</b></br>`+`${this.point.series.name}: <b>${formatIntegerPrice(this.point.y,2,2)}</b>`
                  }:function () {
                      return  `<b>${this.key}</b></br>`+`${this.point.series.name}: <b>${Highcharts.numberFormat(this.point.y,0)}</b>`
                  },
              },
              colors:['#154579', '#265c38','#93b5e9','#d29605','#E87722','#e99e66'],
              plotOptions: {
                  series: {
                      //sstacking: 'normal',
                      borderWidth: 0,
                      pointPadding: 0,
                      groupPadding: 0
                  },
                  bar: {
                      //opacity: 0.9,
                      borderRadius: "20%",
                      groupPadding: 0.05,
                      pointPadding: 0.05,
                      //pointWidth:20,
                      /*groupPadding: 0,
                      pointPadding: 0,
                      maxPadding:0,*/
                      dataLabels: {
                          //padding:0,
                          style:{
                              //fontFamily: 'monospace',
                              //fontSize: '1em',
                              fontWeight:'normal',
                              //color: this.colors[i],
                              textOutline:'none',
                              //border:'1px solid #e344343'
                          },
                          //inside: true,
                          enabled: true,
                          formatter:this.isPriceChart? function (e) {
                              return  formatIntegerPrice(this.y,2,2)
                          }:function (){
                              return  Highcharts.numberFormat(this.y, 0)
                          },
                      },
                      //groupPadding: 0.1,
                  },
              },
              /*legend: {
                  layout: "vertical",
                  align: "right",
                  verticalAlign: "top",
                  x: -40,
                  y: 80,
                  floating: true,
                  borderWidth: 1,
                  backgroundColor:
                      Highcharts.defaultOptions.legend.backgroundColor ||
                      "#FFFFFF",
                  shadow: true,
              },*/
              credits: {
                  enabled: false,
              },
              series: (this.series || []).map((serie) => ({ ...serie, name: tb(serie.name) })),
          };
      },
  },
  methods:{
      formateQty(val){
          return Highcharts.numberFormat(val, 0)
      },
  }
};
</script>

<style></style>
